import { Theme } from "@mui/material/styles";

const styles = (theme: Theme) =>
  ({
    layout: {
      minHeight: 'calc(100% - 196px)',
    },
  } as any);

export default styles;
